module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-palermo.svg?a603e473dee7b05556b4a40ae3707a1e";